export default {
    addcount(state){
        state.count += 1;
    }
}